import { useQuery } from '@tanstack/react-query';

import { Permissions } from '@air/api';
import { useShortIdContext } from '@air/provider-short-id';
import { ONE_DAY } from '@air/utilities';

const getAnyPermissionsKey = (shortId: string | undefined) => ['ANY_PUBLIC_PERMISSIONS', shortId];

export const useFetchAnyPublicPermissions = () => {
  const { shortId } = useShortIdContext();

  return useQuery({
    queryKey: getAnyPermissionsKey(shortId),

    queryFn: () =>
      Permissions.getFromObjects({
        shortId,
        mode: 'any',
        objects: undefined,
      }),
    staleTime: ONE_DAY,
    enabled: !!shortId,
  });
};
